module.exports = __webpack_public_path__ + "static/media/excel3.dec9778b.PNG";